module.exports = __webpack_public_path__ + "static/media/payment5.fd13a3b0.png";